import AutopaymentAuthorization from 'features/advance/screens/registration/AutopaymentAuthorization/AutopaymentAuthorization';
import React from 'react';

const AutopaymentAuthorizationPage = () => {
  return <AutopaymentAuthorization />;
};

export default AutopaymentAuthorizationPage;
